export default __webpack_public_path__ + "static/bg_image_blue@2x-266dc48f04d6a44c53b511e611de86bc.jpg";